module.exports = __webpack_public_path__ + "a1df3856df6dfd0afdb6a6f2aca6d13d.png";